import { message } from '@tencent/tea-component';
import { OpenToastApi } from './Toast.type';
import './Toast.scss';

export const openToast: OpenToastApi = (content, duration = 3000) => {
  message.success({
    content,
    duration,
    className: 'meeting-toast',
  });
};
